import React from 'react';
import "./css/Trending.css";
import { Link } from 'react-router-dom';

function Trending({ item }) {
  return (
    <div className='trendingp'>
      <Link to={`/product-detail/${item?.itemOrdered}`}>
        <div className='img'>
          <img src={item?.image} alt={item?.itemOrdered} />
        </div>
        <div className='trending-p'>
          <p>{item?.itemOrdered}</p>
          <p>{item?.productDesc}</p>
        </div>
        <b>{item?.quantity} Delivered</b>
      </Link>
    </div>
  );
}

export default Trending;